import { useEffect, useState } from "react";
import MemberTable from "./MemberTable";

import { getEmployees } from "../services/employeeService";

import {
  getWorkspaces,
  getWorkspaceMembers,
} from "../services/workspaceService";

const Members = ({ project }) => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const projectUuid =
    project?.uuid ||
    project?.project_uuid ||
    project?.projectUuid;

  useEffect(() => {
    if (!projectUuid) return;

    fetchMembers();
  }, [projectUuid]);

  const getArray = (response) => {
    if (Array.isArray(response)) return response;

    if (Array.isArray(response?.data)) {
      return response.data;
    }

    if (Array.isArray(response?.data?.data)) {
      return response.data.data;
    }

    return [];
  };

  const fetchMembers = async () => {
    try {
      setLoading(true);
      setError("");

      // Get employees
      const employeesResponse = await getEmployees();
      const employees = getArray(employeesResponse);

      // Get project workspaces
      const workspaceResponse =
        await getWorkspaces(projectUuid);

      const workspaces = getArray(workspaceResponse);

      // Employee lookup
      const employeeMap = new Map();

      employees.forEach((employee) => {
        const id =
          employee?.uuid ||
          employee?.employee_uuid ||
          employee?.id;

        if (id) {
          employeeMap.set(String(id), employee);
        }
      });

      // Unique employee map
      const memberMap = new Map();

      // Get members from every workspace
      for (const workspace of workspaces) {
        const workspaceUuid =
          workspace?.uuid ||
          workspace?.workspace_uuid ||
          workspace?.id;

        if (!workspaceUuid) continue;

        const workspaceName =
          workspace?.workspace_name ||
          workspace?.name ||
          workspace?.workspaceName ||
          "Unnamed Workspace";

        const response =
          await getWorkspaceMembers(workspaceUuid);

        const workspaceMembers =
          getArray(response);

        console.log(
          "WORKSPACE:",
          workspaceName
        );

        console.log(
          "WORKSPACE MEMBERS:",
          workspaceMembers
        );

        workspaceMembers.forEach((member) => {
          const employeeUuid =
            member?.employee_uuid ||
            member?.employeeUuid ||
            member?.uuid ||
            member?.employee?.uuid;

          if (!employeeUuid) return;

          const id = String(employeeUuid);

          const employee =
            employeeMap.get(id);

          if (!memberMap.has(id)) {
            memberMap.set(id, {
              uuid: id,

              name:
                member?.name ||
                employee?.name ||
                employee?.employee_name ||
                employee?.full_name ||
                "Unknown Employee",

              email:
                member?.email ||
                employee?.email ||
                employee?.email_address ||
                "-",

              role:
                member?.project_role ||
                member?.role ||
                "Member",

              allocation_percentage:
                member?.allocation_percentage ||
                0,

              status:
                member?.status ||
                "Active",

              workspaces: [],
            });
          }

          const existingMember =
            memberMap.get(id);

          // Prevent duplicate workspace
          const alreadyExists =
            existingMember.workspaces.some(
              (item) =>
                item.uuid ===
                String(workspaceUuid)
            );

          if (!alreadyExists) {
            existingMember.workspaces.push({
              uuid: String(workspaceUuid),
              name: workspaceName,
            });
          }
        });
      }

      const finalMembers =
        Array.from(memberMap.values());

      console.log(
        "FINAL MEMBERS:",
        finalMembers
      );

      setMembers(finalMembers);

    } catch (err) {
      console.error(
        "FETCH MEMBERS ERROR:",
        err
      );

      setError(
        err?.response?.data?.message ||
        "Failed to load project members."
      );
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="rounded-xl border border-slate-200 bg-white p-8 text-center">
        <p className="text-sm text-slate-500">
          Loading project members...
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="rounded-xl border border-red-200 bg-red-50 p-6">
        <p className="text-sm text-red-600">
          {error}
        </p>
      </div>
    );
  }

  return <MemberTable members={members} />;
};

export default Members;